import { render } from "./LearnAboutFriends.vue?vue&type=template&id=27756e5c&scoped=true"
import script from "./LearnAboutFriends.vue?vue&type=script&lang=js"
export * from "./LearnAboutFriends.vue?vue&type=script&lang=js"

import "./LearnAboutFriends.vue?vue&type=style&index=0&id=27756e5c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27756e5c"]])

export default __exports__